// src/lib/kanbanClient.js
import axios from "axios";

const API_BASE = "https://w6mxt54h5f.execute-api.us-east-2.amazonaws.com/Prod/kanban";

const client = async (getAccessTokenSilently) => {
  const token = await getAccessTokenSilently();
  return axios.create({
    baseURL: API_BASE,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export async function getBoards(getAccessTokenSilently) {
  const cx = await client(getAccessTokenSilently);
  const { data } = await cx.get("/boards");
  return data.boards || [];
}

export async function getLists(getAccessTokenSilently, boardId) {
  const cx = await client(getAccessTokenSilently);
  const { data } = await cx.get(`/boards/${boardId}/lists`);
  return data.lists || [];
}

export async function getTasksForList(getAccessTokenSilently, { boardId, listId, limit = 200 }) {
  const cx = await client(getAccessTokenSilently);
  const { data } = await cx.get(`/tasks`, { params: { boardId, listId, limit } });
  return data.tasks || [];
}

export async function createTask(getAccessTokenSilently, payload) {
  const cx = await client(getAccessTokenSilently);
  const { data } = await cx.post(`/tasks`, payload);
  return data.task;
}

export async function updateTask(getAccessTokenSilently, taskId, body) {
  const cx = await client(getAccessTokenSilently);
  const { data } = await cx.patch(`/tasks/${taskId}`, body);
  return data.task;
}

export async function deleteTask(getAccessTokenSilently, taskId) {
  const cx = await client(getAccessTokenSilently);
  await cx.delete(`/tasks/${taskId}`);
}

export async function createList(getAccessTokenSilently, boardId, { listName, afterListId }) {
  const cx = await client(getAccessTokenSilently);
  const { data } = await cx.post(`/boards/${boardId}/lists`, { listName, afterListId });
  return data.list;
}

export async function createBoard(getAccessTokenSilently, { name, type }) {
  const cx = await client(getAccessTokenSilently);
  const { data } = await cx.post(`/boards`, { name, type });
  return data.board;
}